import API from "../../services/api";

function q(params = {}) {
  return { params };
}

export function getDashboard(payPeriodId) {
  return API.get("/disbursement/dashboard", q(payPeriodId ? { pay_period_id: payPeriodId } : {}))
    .then((r) => r.data);
}

export function getBankTransferRegister(batchId) {
  return API.get(
    "/disbursement/reports/bank-transfer-register",
    q(batchId ? { batch_id: batchId } : {})
  ).then((r) => r.data);
}

export function getSalaryPaymentRegister(payPeriodId) {
  return API.get("/disbursement/reports/salary-register", q({ pay_period_id: payPeriodId })).then(
    (r) => r.data
  );
}

export function getFailedPayments(payPeriodId) {
  return API.get(
    "/disbursement/reports/failed-payments",
    q(payPeriodId ? { pay_period_id: payPeriodId } : {})
  ).then((r) => r.data);
}

export function getPendingPayments(payPeriodId) {
  return API.get(
    "/disbursement/reports/pending-payments",
    q(payPeriodId ? { pay_period_id: payPeriodId } : {})
  ).then((r) => r.data);
}

export function getBankWiseSummary(payPeriodId) {
  return API.get(
    "/disbursement/reports/bank-wise-summary",
    q(payPeriodId ? { pay_period_id: payPeriodId } : {})
  ).then((r) => r.data);
}

export function getBranchWiseSummary(payPeriodId) {
  return API.get(
    "/disbursement/reports/branch-wise-summary",
    q(payPeriodId ? { pay_period_id: payPeriodId } : {})
  ).then((r) => r.data);
}

export function getDepartmentWiseSummary(payPeriodId) {
  return API.get(
    "/disbursement/reports/department-wise-summary",
    q(payPeriodId ? { pay_period_id: payPeriodId } : {})
  ).then((r) => r.data);
}
